export const filterConfig = [
  {
    id: 'Nome',
    type: 'text',
    label: 'Nome',
    placeholder: 'Digite o nome do motorista',
  },
  {
    id: 'Cpf',
    type: 'text',
    label: 'CPF',
    placeholder: 'Digite o CPF',
  },
  {
    id: 'CodigoIntegracao',
    type: 'text',
    label: 'Código de Integração',
    placeholder: 'Digite o código de integração',
  },
  {
    id: 'Tipo',
    type: 'select',
    label: 'Tipo',
    placeholder: 'Selecione o tipo',
    options: [
      { value: '', label: 'Todos' },
      { value: 'Terceiro', label: 'Terceiro' },
      { value: 'Próprio', label: 'Próprio' },
    ],
  },
  {
    id: 'Ativo',
    type: 'select',
    label: 'Status',
    placeholder: 'Selecione o status',
    options: [
      { value: '', label: 'Todos' },
      { value: '1', label: 'Ativo' },
      { value: '0', label: 'Inativo' },
    ],
  },
];
